import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiAssistantsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#0517f8",
			fillRule: "evenodd",
			stroke: "#0517f8",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "M4.999 2.497a3.335 3.335 0 0 1-3.335 3.335A3.335 3.335 0 0 1 5 9.166a3.335 3.335 0 0 1 3.335-3.334 3.335 3.335 0 0 1-3.335-3.335M14.168 12.501A4.17 4.17 0 0 0 10 8.333a4.17 4.17 0 0 0 4.168-4.169 4.17 4.17 0 0 0 4.169 4.169 4.17 4.17 0 0 0-4.169 4.168",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#0517f8",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "M14.169 12.501v.834M14.169 4.164v-.833M8.333 17.503v.834M8.333 11.667v-.833M4.999 9.166V10M4.999 1.663v.834"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0517f8",
			fillRule: "evenodd",
			stroke: "#0517f8",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "M8.333 11.25a3.335 3.335 0 0 1-3.335 3.335 3.335 3.335 0 0 1 3.335 3.335 3.335 3.335 0 0 1 3.335-3.335 3.335 3.335 0 0 1-3.335-3.335",
			clipRule: "evenodd"
		})
	]
});
export default SvgAiAssistantsActive;
